/**
 * Facebook Pixel tracking utilities
 * Captures fbclid (from URL) and _fbp (from cookie) for proper attribution
 */

const FBC_KEY = 'fb_fbc';

/**
 * Get cookie value by name
 */
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

/**
 * Capture fbclid from URL and build fbc parameter
 * Should be called on initial page load
 */
export const captureFbclid = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    
    if (fbclid) {
      // Build fbc: fb.{subdomain_index}.{creation_timestamp}.{fbclid}
      // subdomain_index: 1 for .com domains
      const timestamp = Date.now();
      const fbc = `fb.1.${timestamp}.${fbclid}`;
      
      // Store in localStorage for later use
      localStorage.setItem(FBC_KEY, fbc);
      
      return fbc;
    }
    
    // Return existing fbc if already captured
    return localStorage.getItem(FBC_KEY);
  } catch (e) {
    console.error('Error capturing fbclid:', e);
    return null;
  }
};

/**
 * Get stored fbc (Facebook click ID)
 */
export const getFbc = () => {
  return localStorage.getItem(FBC_KEY);
};

/**
 * Get _fbp cookie (Facebook browser ID) - set automatically by FB Pixel
 */
export const getFbp = () => {
  return getCookie('_fbp');
};

/**
 * Get all FB tracking params for sending to CAPI
 */
export const getFbTrackingParams = () => {
  return {
    fbc: getFbc(),
    fbp: getFbp()
  };
};
